import axios from "axios";

export const state = {
    doctorspecialty: [],
};

export const getters = {
    doctorspecialty: state => state.doctorspecialty,
};

export const mutations = {
    setDoctorspecialty(state, newValue) {
        state.doctorspecialty = newValue
    },
};

export const actions = {
    fetchDoctorspecialty({ commit }) {
        axios.get('/doctorspecialty').then(res => {
            commit('setDoctorspecialty', res.data.categories)
        })
    },
};
